var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-product-micro"},[_c('VMicroFrontProvider',{attrs:{"micro-front-name":"product","route-name":`product/${_vm.productId}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }